import { env } from '@/lib/env';

/**
 * One call site for product analytics. Mixpanel is loaded only when its token
 * is set; without it, events go to the console in development and nowhere in
 * production. Error reporting is deliberately not wired (decision 2026-10-21:
 * no Sentry in frontend 2.0 for now).
 */
type Props = Record<string, string | number | boolean | null | undefined>;

interface Sink {
  identify: (userId: string, props?: Props) => void;
  track: (event: string, props?: Props) => void;
  reset: () => void;
}

const consoleSink: Sink = {
  identify: (userId) => {
    if (import.meta.env.DEV) console.warn(`[identify] ${userId}`);
  },
  track: (event, props) => {
    if (import.meta.env.DEV) console.warn(`[track] ${event}`, props ?? {});
  },
  reset: () => undefined,
};

let sink: Sink = consoleSink;

export function initTelemetry(): void {
  if (!env.VITE_MIXPANEL_TOKEN) return;
  // Mixpanel is wired in Phase 8 (hardening) once the event list is agreed; until then the console sink stands in.
}

export function identify(userId: string, props?: Props): void {
  sink.identify(userId, props);
}

export function track(event: string, props?: Props): void {
  sink.track(event, props);
}

export function resetTelemetry(): void {
  sink.reset();
}

/** Test seam. */
export function setTelemetrySink(next: Sink | null): void {
  sink = next ?? consoleSink;
}
